export default __webpack_public_path__ + "static/media/IBFL.d03ff700.png";